'use strict';

angular.module('risevision.rva.services')
  .factory('storeProductsFactory', ['$modal', '$log',
    function ($modal, $log) {
      var factory = {};

      factory.open = function () {
        var modalInstance = $modal.open({
          templateUrl: 'partials/components/store-products/store-content-modal.html',
          size: 'lg',
          controller: 'storeContentModal',
          resolve: {
            addWidgetByUrl: function () {
              return null;
            }
          }
        });

        return modalInstance.result.then(function(productDetails) {
          return productDetails.productCode;
        });
      };

      return factory;
    }
  ]);
